/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query LBRRoutePlanReadQuery($routeId: ID!, $mccNameToSearch: String, $mncNameToSearch: String, $countryNameToSearch: String, $take: PositiveInt, $skip: Int) {
    LBRRoutePlanRead(routeId: $routeId, mccNameToSearch: $mccNameToSearch, mncNameToSearch: $mncNameToSearch, countryNameToSearch :$countryNameToSearch,take: $take, skip: $skip) {
      id
      createdAt
      updatedAt
      status,
      _totalCount,
      Mcc {
        mcc,
        countryName,
      },
      Mnc {
        mnc,
      }
      LBRRoute {
        id
        displayName
      }
    }
  }
`
